/* Comparador antes/después — inicializa cualquier [data-cad-frame] presente
   en la página, y sigue vigilando el DOM para inicializar instancias nuevas
   que aparezcan por recargas de sección en el editor del tema (esas recargas
   inyectan HTML sin volver a ejecutar <script> embebidos). */
(function () {
  function initFrame(frame) {
    if (frame.dataset.cadReady === 'true') return;
    frame.dataset.cadReady = 'true';

    var beforeWrap = frame.querySelector('[data-cad-before]');
    var handle = frame.querySelector('[data-cad-handle]');
    if (!beforeWrap || !handle) return;

    var initial = parseFloat(frame.dataset.initial) || 50;
    var playIntro = frame.dataset.playIntro === 'true';
    var pos = initial;
    var dragging = false;

    function apply(p) {
      pos = Math.min(100, Math.max(0, p));
      beforeWrap.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }

    function posFromEvent(evt) {
      var rect = frame.getBoundingClientRect();
      var x = (evt.touches ? evt.touches[0].clientX : evt.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    function onPointerDown(evt) {
      dragging = true;
      frame.classList.remove('cad-intro');
      apply(posFromEvent(evt));
      evt.preventDefault();
    }
    function onPointerMove(evt) {
      if (!dragging) return;
      apply(posFromEvent(evt));
    }
    function onPointerUp() { dragging = false; }

    frame.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    handle.addEventListener('keydown', function (evt) {
      if (evt.key === 'ArrowLeft') { frame.classList.remove('cad-intro'); apply(pos - 5); evt.preventDefault(); }
      if (evt.key === 'ArrowRight') { frame.classList.remove('cad-intro'); apply(pos + 5); evt.preventDefault(); }
      if (evt.key === 'Home') { frame.classList.remove('cad-intro'); apply(0); evt.preventDefault(); }
      if (evt.key === 'End') { frame.classList.remove('cad-intro'); apply(100); evt.preventDefault(); }
    });

    apply(initial);

    if (playIntro && 'IntersectionObserver' in window) {
      var played = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !played) {
            played = true;
            frame.classList.add('cad-intro');
            apply(Math.max(0, initial - 16));
            setTimeout(function () { apply(Math.min(100, initial + 16)); }, 550);
            setTimeout(function () { apply(initial); frame.classList.remove('cad-intro'); }, 1150);
            io.disconnect();
          }
        });
      }, { threshold: 0.4 });
      io.observe(frame);
    }
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('[data-cad-frame]')) initFrame(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('[data-cad-frame]').forEach(initFrame);
    }
  }

  scan(document.body);

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) { scan(n); });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
